/**
 * UserDashboard Component
 * Combined dashboard showing call history, usage stats, and billing information
 */

import React, { useState } from 'react';
import UserBoard from './UserBoard.js';
import Billing from './Billing.js';
import CreditUsagePanel from './CreditUsagePanel.js';
import { CreditCard, BarChart3, Coins } from 'lucide-react';

const UserDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview'); // 'overview' | 'credits' | 'billing'

  const tabs = [
    { id: 'overview', label: 'Overview', icon: BarChart3 },
    { id: 'credits', label: 'Credits', icon: Coins },
    { id: 'billing', label: 'Billing', icon: CreditCard }
  ];

  return (
    <div className="h-full flex flex-col bg-freshroad-off-white">
      {/* Tab Navigation */}
      <div className="bg-white border-b border-gray-200 px-6">
        <div className="flex items-center gap-1">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  px-6 py-4 text-sm font-medium border-b-2 transition-colors
                  flex items-center gap-2
                  ${
                    activeTab === tab.id
                      ? 'border-freshroad-teal text-freshroad-teal'
                      : 'border-transparent text-gray-600 hover:text-freshroad-black hover:border-gray-300'
                  }
                `}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-hidden">
        {activeTab === 'overview' && <UserBoard />}
        {activeTab === 'credits' && <CreditUsagePanel />}
        {activeTab === 'billing' && <Billing />}
      </div>
    </div>
  );
};

export default UserDashboard;

